import { useMutation } from '@tanstack/react-query';

import Client from './client';

import type { UseMutationOptions } from '@tanstack/react-query';

export const useBarcodeCarrierValidate = (
  options: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof Client.validateBarcode>>,
      Error,
      Parameters<typeof Client.validateBarcode>[0],
      unknown
    >,
    'mutationFn'
  > = {},
) => {
  const { mutateAsync, status } = useMutation({
    mutationFn: Client.validateBarcode,
    ...options,
  });

  return {
    validateBarcodeCarrierMutateAsync: mutateAsync,
    validateBarcodeCarrierStatus: status,
  };
};
